import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';

const RegisterAdmin = () => {
    
    const { authState } = useOktaAuth();

    useEffect(() => {
        if (authState) {
            console.log(authState)
        }
    }, [authState])
    return <>
    </>
}

export default RegisterAdmin;